import React, { useState, useEffect } from "react";
import { Validation } from '../../utils/validation';
import ShareMessageModal from './ShareMessageModal';
import './Modal.css';

const ShareQuoteMeModal = ({ isShow, onClose, onShare }) => {
    const [fields, setFields] = useState({});
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showShareMessageModal, setShowShareMessageModal] = useState(false);

    useEffect(() => {
        if (isShow) {
            setFields({});
            setErrors({});
            setSuccessMessage('');
            setErrorMessage('');
        }
    }, [isShow]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });
        setErrors({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = Validation(fields, ['email']);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            setShowShareMessageModal(true);
            await onShare(fields.email, fields.note);   // 🔥 parent controls logic
            setSuccessMessage('Quote shared successfully');
            setErrorMessage('');
            onClose();
        } catch (err) {
            setErrorMessage(err?.message || 'Failed to share quote');
            setSuccessMessage('');
        }

        setTimeout(() => {
            setShowShareMessageModal(false);
        }, 2000);
    };

    return (
        <>
            {isShow && (
                <div className="motor-modal-overlay">
                    <div className="motor-modal-content">
                        <form className="motor-error-report-form d-flex flex-column gap-3" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="email" 
                                    id="email"
                                    value={fields.email || ''}
                                    onChange={handleChange}
                                    style={{ backgroundColor: '#E4E4E4' }}
                                />
                                {errors.email && (
                                    <div className="text-danger">{errors.email}</div>
                                )}
                            </div>
                            <div className="form-group">
                                <label>If your Quote has turned into an order AWESOME JOB! Please include the PO number in the notes below. Or just add special notes for your customer to see. These notes will appear in the body of the email.</label>
                            </div>
                            <div className="form-group">
                                <label htmlFor="note">Note</label>
                                <textarea className="form-control" name="note" id="note" onChange={handleChange} rows="6" style={{ border:"1px solid"}} value={fields.note || ''}></textarea>
                            </div>

                            <div className="d-flex w-100 justify-content-evenly gap-4">
                                <button
                                    type="button"
                                    className="btn btn-secondary w-50"
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="submit-button w-50 submit-error-report"
                                >
                                    Share
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <ShareMessageModal
                isShow={showShareMessageModal}
                successMessage={successMessage}
                errorMessage={errorMessage}
                onClose={() => setShowShareMessageModal(false)}
            />
        </>
    );
};

export default ShareQuoteMeModal;